var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnFriends(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 481",
    style: {
      fill: "none"
    },
    d: "M0 0h44v44H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21H12v-2.25A3.755 3.755 0 0 1 15.75 15h3a3.755 3.755 0 0 1 3.75 3.75V21H21v-2.25a2.253 2.253 0 0 0-2.25-2.25h-3a2.253 2.253 0 0 0-2.25 2.25V21zm-12-6H0v-2.25A3.754 3.754 0 0 1 3.75 9h3a3.754 3.754 0 0 1 3.75 3.749V15H9v-2.25a2.252 2.252 0 0 0-2.25-2.25h-3a2.252 2.252 0 0 0-2.25 2.249V15zm15.75-1.5A3.75 3.75 0 1 1 21 9.75a3.755 3.755 0 0 1-3.75 3.75zm0-6a2.25 2.25 0 1 0 2.25 2.25 2.252 2.252 0 0 0-2.25-2.25zm-12 0A3.75 3.75 0 1 1 9 3.75 3.755 3.755 0 0 1 5.25 7.5zm0-6A2.25 2.25 0 1 0 7.5 3.75 2.253 2.253 0 0 0 5.25 1.5z",
    transform: "translate(11 11)",
    style: {
      fill: "#505866"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFriends);
export default __webpack_public_path__ + "static/media/icn_friends.277fffbde6097449da0585471c24e89d.svg";
export { ForwardRef as ReactComponent };